import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

import { FinanceiroLabels } from "@/lib/labels/financeiro";
import { format } from "@/lib/format";
import type { BankMovement } from "@/types/financeiro";

function payerDocument(movement: BankMovement) {
	if (movement.payer_document === null) {
		return null;
	}

	if (movement.payer_document_kind === "cpf") {
		return format.cpf(movement.payer_document);
	}

	if (movement.payer_document_kind === "cnpj" && movement.payer_document.length === 14) {
		const value = movement.payer_document;

		return `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12)}`;
	}

	return movement.payer_document;
}

export function BankMovementContext({ movement }: { movement: BankMovement }) {
	const Icon = movement.direction === "income" ? ArrowDownLeft : ArrowUpRight;
	const document = payerDocument(movement);

	return (
		<div
			data-component="financeiro-bank-movement-context"
			className="flex items-start justify-between gap-4 rounded-lg border border-border bg-background px-3 py-2.5"
		>
			<div className="flex min-w-0 items-center gap-3">
				<Icon className="size-4 shrink-0 text-primary" />
				<div className="min-w-0">
					<p className="text-xs font-medium text-muted-foreground">
						{movement.direction === "income" && "Entrada bancária"}
						{movement.direction === "expense" && "Saída bancária"}
					</p>
					<p className="break-words text-sm font-semibold text-foreground">
						{movement.description ?? "Movimento bancário"}
					</p>
					{movement.payer_name !== null && (
						<p className="mt-1 text-xs text-muted-foreground">{movement.payer_name}</p>
					)}
					{document !== null && (
						<p className="font-mono text-xs text-muted-foreground">{document}</p>
					)}
					<p className="mt-1 text-xs text-muted-foreground">
						{format.date(movement.effective_on)}
						{movement.method !== null && `, ${movement.method}`}
					</p>
				</div>
			</div>
			<p className="shrink-0 font-mono text-sm font-semibold text-foreground">
				{FinanceiroLabels.money(movement.amount_cents)}
			</p>
		</div>
	);
}
